import { Box, BoxProps, Text, TextProps } from '@jfs/ui-new'
import { Icon } from '@jfs/ui-new/src/comps/IconNew'
import { View, ViewProps } from 'react-native'

export const RefundHeader = ({ navigation, options }: any) => {
  const canGoBack = navigation?.canGoBack()
  return (
    <View style={[styles.container, options.headerStyle]}>
      <Box {...styles.titleContainer}>
        <Text {...styles.titleStyle}>{options.headerTitle}</Text>
      </Box>
      <Box
        onPress={() => {
          if (canGoBack) {
            navigation?.goBack()
          } else {
            window.onBackPress()
          }
        }}
        height={'100%'}
        underlayColor={'TRANSPARENT'}
        ph={10}
        justifyContent={'center'}>
        <Icon id={'ARROW_BACK'} color="BRAND_COLOR_GRAY_1" size={20} />
      </Box>
    </View>
  )
}

const styles = {
  container: {
    flexDirection: 'row',
    ph: 16,
    height: 48,
    backgroundColor: '#FFFFFF',
    alignItems: 'center',
    borderBottomWidth: 1,
    borderBottomColor: '#CCCCCC',
  } as ViewProps,
  titleStyle: {
    fontSize: 14,
    fontFamily: 'jioType-medium',
    color: 'BRAND_COLOR_GRAY_1',
  } as TextProps,
  titleContainer: {
    position: 'absolute',
    alignSelf: 'center',
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    alignItems: 'center',
    justifyContent: 'center',
  } as BoxProps,
}
